import { listGroups, listMembers } from '@modusign/openapi-client-user';
import { ListGroupsParams, ListMembersParams } from '@modusign/openapi-client-user/generated/model';
import { useQuery } from 'react-query';

import { adaptWorkspaceGroup, adaptWorkspaceMember } from '@app/features/workspaceManagement/types';

export function getListResourceRoleSubjectsQueryKey(
  workspaceId: string,
  params?: ListMembersParams | ListGroupsParams
) {
  return ['resourceRoleSubjects', workspaceId, ...(params ? [params] : [])];
}

export async function listResourceRoleSubjects(
  workspaceId: string,
  params?: ListMembersParams | ListGroupsParams
) {
  const { offset, limit } = params ?? {};

  const [members, groups] = await Promise.all([
    listMembers(workspaceId, { offset, limit }),
    listGroups(workspaceId, { offset, limit }),
  ]);

  return { members, groups };
}

export function useListResourceRoleSubjects(
  workspaceId: string,
  params?: ListMembersParams | ListGroupsParams
) {
  return useQuery({
    queryKey: getListResourceRoleSubjectsQueryKey(workspaceId, params),
    queryFn: () => listResourceRoleSubjects(workspaceId, params),
    select: ({ members, groups }) => ({
      count: members.count + groups.count,
      subjects: [
        ...members.members.map((m) => adaptWorkspaceMember(m)),
        ...groups.groups.map((g) => adaptWorkspaceGroup(g)),
      ],
    }),
  });
}
